<template>
  <div
    class="section-container"
    :class="{ 'extra-row': currentGrade.grade == 3 }"
  >
    <p class="title">7. Additional Components</p>
    <br />
    <textarea
      class="textarea"
      v-model="currentGrade.comments"
      placeholder="Please provide any other comments on the quality of this theme"
    ></textarea>
    <div class="evaluation">
      <p class="subtitle--bold">Evaluation Criteria</p>
      <br />
      <div class="accordion-container">
        <div
          class="accordion is-open"
          v-for="(criteria, i) in criterion"
          :key="i"
        >
          <div
            class="accordion-header"
            style="background: linear-gradient(90deg, #00B9C1, transparent); font-weight: 600;"
          >
            The QHA Includes:
          </div>
          <div class="accordion-body" style="max-height: 100%">

            <div class="accordion-item-wrapper"
              v-for="option in options" :key="option"
            >
              <div class="accordion-item">
                <div class="accordion-checkbox">
                  <input
                    class="accordion-checkbox-input"
                    type="checkbox"
                    @change="
                      accordionItemToggled($event, { criteria, selected: option })
                    "
                    :value="option"
                    v-model="cache"
                  />
                </div>
                <div class="accordion-label">{{ option }}</div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="button-row">
      <div class="info-row">
        <p class="link link--back">
          <i class="fas fa-chevron-circle-left"></i>
          <a @click="$router.go(-1)">Back</a>
        </p>
      </div>
      <div class="info-row info-row--right">
        <p class="link">
          <a @click="next">Next Theme</a>
          <i class="fas fa-chevron-circle-right"></i>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { additionalComponents } from '@/mocks/audit'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'AdditionalInformation',
  data() {
    return {
      showToolTip: false,
      openAccordion: null,
      additionalComponents,
      currentGrade: {
        grade: null,
        comments: null,
        criteria: {
          optional: []
        }
      },
      cache: [],
      hasSelectedGrade: false
    }
  },
  computed: {
    ...mapGetters({
      sections: 'audit/sections',
      currentAudit: 'audit/currentAudit'
    }),
    currentSectionId() {
      return 'additional-components'
    },

    options() {
      return this.additionalComponents.criteria.optional
    },
    criterion() {
      return Object.keys(this.additionalComponents.criteria)
    },
    grades() {
      return this.additionalComponents.grades
    },
    savedSection() {
      console.log({ currentAudit: this.currentAudit })
      const hasSection =
        this.currentAudit && Array.isArray(this.currentAudit.sections)
      return hasSection
        ? this.currentAudit.sections.find(s => s.id === 'additional-components')
        : null
    }
  },
  methods: {
    ...mapActions({ setGrade: 'audit/setGrade' }),
    async next() {
      try {
        await this.setGrade({
          id: 'additional-components',
          name: '7. Additional Components',
          ...this.currentGrade
        })

        this.$router.push('/plans/audit/next-steps')
      } catch (err) {
        console.log({ err })
      }
    },
    accordionItemToggled(event, { criteria, selected }) {
      const { checked } = event.target
      console.log({ checked, criteria, selected })
      checked
        ? this.currentGrade.criteria.optional.push(selected)
        : (this.currentGrade.criteria.optional = this.currentGrade.criteria.optional.filter(
          existing => existing !== selected
        ))
      this.hasSelectedGrade = this.currentGrade.criteria.optional.length > 0
    }
  },
  mounted() {
    if ('sections' in this.currentAudit === false) {
      this.$router.push('/plans/select')
    }
    if (this.savedSection) {
      this.currentGrade.criteria.optional.splice()
      this.currentGrade.criteria.optional.push(
        ...this.savedSection.criteria.optional
      )
      this.cache = this.savedSection.criteria.optional
      this.currentGrade.comments = this.savedSection.comments
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/variables.scss';
@import '@/style/components.scss';
@import '@/style/sections.scss';
@import '@/style/transitions.scss';
@import '@/style/accordion.scss';

.button-row {
  display: flex;
  align-content: center;
  padding-bottom: 20px;
  height: 100%;
}
</style>
